var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disposer-app-editor"},[(_vm.title)?_c('div',{staticClass:"disposer-app-topic-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('app-ckeditor',{ref:"ckeditor",attrs:{"config":_vm.editorConfig},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }